import React, { useEffect, useRef, useState } from "react";
import styled from 'styled-components';
import RightArrowIcon from "./RightArrowIcon";
import LeftArrowIcon from "./LeftArrowIcon";

const CharDhamCardContainer = styled.div`
    margin-top: 20px;
    padding-left: 200px;
    padding-right: 200px;
    @media (max-width: 1477px) {
      padding-left: 50px;
      padding-right: 50px;
    }
`;

const CharDhamContainer = styled.div`
  margin-top: 22px;
  margin-right: 30px;
  flex: 0 0 auto;
  width: 330px; 
`;

const CharDhamCardImage = styled.img`
  width: 100%;
  border-radius: 32px;
`;

const CharDhamCardTitle = styled.p`
  margin-top: 8px;
  font-size: 18px;
  font-weight: bold;
`;

const CharDhamCardDescription = styled.p`
  color: #4a4a4a;
  font-size: 14px;
  margin-top: 2px;
`;

const ViewCabsButton = styled.div`
    border-radius: 8px;
    background-color: #FF6D38;
    padding: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    cursor: pointer;
    `;
const ViewCabsButtonText = styled.p`
    color: white;
    font-weight: bold;
    font-size: 14px;
`;

const HeadingText = styled.p`
    font-size: 24px;
    font-weight: bold;
    margin-top: 24px;
`;

const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  overflow-x: auto; /* Enable horizontal scrolling */
  scroll-behavior: smooth;
  scrollbar-width: none; /* Hide scrollbar for Firefox */
  -ms-overflow-style: none; /* Hide scrollbar for IE and Edge */
  
  &::-webkit-scrollbar {
    display: none; /* Hide scrollbar for Chrome, Safari, and Opera */
`
const ArrowButton = styled.button`
  background: white;
  border: none;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); 
  
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ right }) => (right ? 'right: -20px;' : 'left: -20px;')}
  
  svg {
    fill: #2276e3;
    width: 24px; 
    height: 24px;
  }
`;

const ScrollerWrapper = styled.div`
  position: relative;
  flex: 1;
`;

const CharDhamCard = ({ charDhams, trackEvent }) => {
  const scrollerRef = useRef(null);
  const [isAtStart, setIsAtStart] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (scrollerRef.current) {
        const { scrollLeft, scrollWidth, clientWidth } = scrollerRef.current;
        setIsAtStart(scrollLeft === 0);
        setIsAtEnd(scrollLeft + clientWidth >= scrollWidth - 1); // Small adjustment for precision
      }
    };

    const checkIfScrollable = () => {
      if (scrollerRef.current) {
        const { scrollWidth, clientWidth } = scrollerRef.current;
        // Hide both arrows if the content fits within the container
        if (scrollWidth <= clientWidth) {
          setIsAtStart(true);
          setIsAtEnd(true);
        } else {
          setIsAtStart(scrollerRef.current.scrollLeft === 0);
          setIsAtEnd(scrollerRef.current.scrollLeft + clientWidth >= scrollWidth - 1);
        }
      }
    };

    if (scrollerRef.current) {
      scrollerRef.current.addEventListener('scroll', handleScroll);
      checkIfScrollable(); 
    }

    window.addEventListener('resize', checkIfScrollable); 

    return () => {
      if (scrollerRef.current) {
        scrollerRef.current.removeEventListener('scroll', handleScroll);
      }
      window.removeEventListener('resize', checkIfScrollable);
    };
  }, []);

  const handleScroll = (direction) => {
    if (scrollerRef.current) {
      const scrollAmount = 500;
      scrollerRef.current.scrollLeft += direction === 'left' ? -scrollAmount : scrollAmount;
    }
  };

  const updateStartTimeToNextDay = (url) => {
    const qryParamsPart = url.split("qryParams=")[1];
    if (!qryParamsPart) return url;

    const decodedParams = decodeURIComponent(qryParamsPart);
    let qryParamsObject;

    try {
        qryParamsObject = JSON.parse(decodedParams);
    } catch {
        return url;
    }
    const nextDay = new Date();
    nextDay.setDate(nextDay.getDate() + 1);
    
    nextDay.setUTCHours(10, 0, 0, 0);
    qryParamsObject.s_t = nextDay.toISOString().slice(0, 16);
    const updatedQryParams = encodeURIComponent(JSON.stringify(qryParamsObject));
    return `${url.split("qryParams=")[0]}qryParams=${updatedQryParams}`;
};

  return (
    <div>
      <HeadingText>Know more about Char Dham</HeadingText>
      <ScrollerWrapper>
        {!isAtStart && (
          <ArrowButton onClick={() => handleScroll('left')} aria-label="Previous Package">
            <LeftArrowIcon />
          </ArrowButton>
        )}
      <CardContainer  ref={scrollerRef}>
        {charDhams.map((item) => (
          <CharDhamContainer key={item.title} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <CharDhamCardImage src={item.gi_img} alt={item.title} />
            <CharDhamCardTitle>{item.title}</CharDhamCardTitle>
            <CharDhamCardDescription>{item.details}</CharDhamCardDescription>
            <ViewCabsButton onClick={()=>{
              trackEvent(`${item?.title}_dham_view_cabs_clicked`)
              window.location = Object(updateStartTimeToNextDay(item?.gi_url));
            }}>
                <ViewCabsButtonText>View Cabs</ViewCabsButtonText>
            </ViewCabsButton>
          </CharDhamContainer>
        ))}
      </CardContainer>
      {!isAtEnd && (
          <ArrowButton right onClick={() => handleScroll('right')} aria-label="Next Package">
            <RightArrowIcon />
          </ArrowButton>
        )}
      </ScrollerWrapper>
    </div>
  );
};

const CharDhamInfo = ({charDhamInfo, trackEvent}) => {
    return (
     <CharDhamCardContainer>
        <CharDhamCard charDhams={charDhamInfo} trackEvent={trackEvent} />
    </CharDhamCardContainer>
    )
}

export default CharDhamInfo;